import React, { Component } from "react";
import { SkyLightStateless } from 'react-skylight';
import _ from 'lodash';
import {
  Button,
} from "react-bootstrap";
import { Translate } from "react-redux-i18n";

const modalStyle = {
  width: '500px',
  height: '450px',
  marginLeft: '-10%',
}

const propTypes = {
}

const defaultProps = {
}

const styles = {
  promotionContainer: {
    width: '100%',
    height: '300px',
    // border: '1px solid red',
    padding: '20px'
    // overflow: 'auto',
  },
  promotionItem: {
    width: '100%',
    display: 'block',
  },
  buttonToolbar: {
    display: 'flex',
    justifyContent: 'space-evenly',
  }
}

class ApplyPromotions extends Component {
  renderPromotionItem = (promotion) => {
    let description = promotion.Description.slice(0, 15);
    if (promotion.Description.length > 14) {
      description += '...';
    }
    return <li>
      {promotion.DiscountDescription} - {description}
    </li>
  }
  render() {
    return (
      <div>
        <div style={styles.promotionContainer}>
          <ol>
            {_.map(this.props.appliablePromotions, promotion => {
              return this.renderPromotionItem(promotion)
            })}
          </ol>
        </div>
        <div style={styles.buttonToolbar}>
          <Button
            bsStyle="primary"
            className="print-btn"
            type="button"
            onClick={() => {
              this.props.applyAndSave();
            }}
          >
            <Translate value="apply" />
          </Button>
          <Button
            bsStyle="primary"
            className="print-btn"
            type="button"
            onClick={() => {
              this.props.notApplyAndSave();
            }}
          >
            {/* <em className="fa fa-pencil" /> */}
            <Translate value="cancel" />
          </Button>
        </div>
      </div>
    )
  }
}

const ApplyPromotionsModal3 = ({ isVisible, setModalVisibility, appliablePromotions, applyAndSave, notApplyAndSave }) => (
  <SkyLightStateless
    title={'Promotion Found'}
    onCloseClicked={setModalVisibility}
    dialogStyles={modalStyle}
    isVisible={isVisible}
  >
    <ApplyPromotions appliablePromotions={appliablePromotions} applyAndSave={applyAndSave} notApplyAndSave={notApplyAndSave} />
  </SkyLightStateless>
)

ApplyPromotionsModal3.propTypes = propTypes
ApplyPromotionsModal3.defaultProps = defaultProps

export default ApplyPromotionsModal3;



// WEBPACK FOOTER //
// ./master/jsx/components/Common/modals/salesOrder/ApplyPromotionsModal3.jsx